import React from 'react';

const CalibrationContext = React.createContext({});

export default CalibrationContext;
